import { jsx as _jsx } from "react/jsx-runtime";
import PlaceholderLogo from '../assets/placeholder-logo.svg';
import { Box } from '@mui/material';
import styles from './LoadingPagePlaceholder.module.scss';
export function LoadingPagePlaceholder() {
    return (_jsx(Box, { className: styles.container, children: _jsx(Box, { className: styles.logo, children: _jsx(PlaceholderLogo, {}) }) }));
}
